import { useEffect, useState } from "react";
import { useDetectClickOutside } from 'react-detect-click-outside';
import styles from "../../../../assets/stylesheets/sass/AdvancedDropdownlist.module.scss"
import style from "../../../../assets/stylesheets/sass/Management/GroupsPopup.module.scss";

import trash from "../../../../assets/icons/trash.svg";
import checkbox from "../../../../assets/icons/checkbox.svg";
import search from "../../../../assets/icons/search_icon.svg";

export const DropdownlistRow = ({value, keys, handleClickItem}) => {
    return (
        <div className={styles.list_row} onClick={()=>{handleClickItem(true)}}>

            <div className={styles.profile_picture}><p>{value[keys.profile_picture].substring(0,1)}</p></div>

            <div className={styles.row_info}>
                <p className={styles.name_top}>{value[keys.name_top]}</p>
                <p className={styles.name_bottom}>{value[keys.name_bottom]}</p>
            </div>

        </div>
    )
}

export const AdvancedDropdownlist = ({data, keys, placeholder, onChange, clear}) => {
    const refContainer = useDetectClickOutside({ onTriggered: function(){setshowDropdown(false)} });

    const [selectedItems, setselectedItems] = useState([]);
    const [listItems, setlistItems] = useState([]);
    const [filtered_listItems, setfiltered_listItems] = useState([]);

    const [showDropdown, setshowDropdown] = useState(false);

    useEffect(()=>{
        setlistItems(data);
        setfiltered_listItems(data);
    }, [data])

    useEffect(()=>{
        if(clear){
            setselectedItems([])
        }
    }, [clear])

    const handleSelectItem = (v) => {
        let tmp_listItems = [...listItems];
        let tmp_selectedItems = [...selectedItems];

        const index = tmp_listItems.indexOf(v);
        if(index > -1){
            tmp_listItems.splice(index, 1)
        }

        tmp_selectedItems.push(v);

        setlistItems(tmp_listItems)
        setfiltered_listItems(tmp_listItems)
        setselectedItems(tmp_selectedItems)
    }

    const handleSearchItem = (value) => {
        let filtered_arr = []
        let tmp_listItems = [...listItems];
        for (let i = 0; i < tmp_listItems.length; i++) {
            Object.keys(keys).forEach(key => {
                if(tmp_listItems[i][keys[key]].toString().toLowerCase().includes(value.toLowerCase()) && filtered_arr.indexOf(tmp_listItems[i]) === -1){
                    filtered_arr.push(tmp_listItems[i])
                }
            })
        }
        setfiltered_listItems(filtered_arr)
    }

    const handleSelectAll = () => {
        console.log("x");
        let tmp_listItems = [...data]
        setselectedItems(tmp_listItems)

        setlistItems([])
        setfiltered_listItems([])
    }

    const removeTag = (v) => {
        let tmp_selectedItems = [...selectedItems];
        let tmp_listItems = [...listItems];
        let tmp_filtered_listItems = [...filtered_listItems];

        const index = tmp_selectedItems.indexOf(v);
        if(index > -1){
            tmp_selectedItems.splice(index, 1)
        }

        tmp_listItems.push(v);
        tmp_filtered_listItems.push(v);

        setfiltered_listItems(tmp_filtered_listItems)
        setlistItems(tmp_listItems)
        setselectedItems(tmp_selectedItems)
    }

    useEffect(()=>{
        onChange(selectedItems)
    }, [selectedItems])

    return (
        <div ref={refContainer} className={styles.dropdown}>
            <div className={styles.input}>

                {Array.isArray(selectedItems) && selectedItems.length > 0 && selectedItems.map((v, i)=> {
                    return <p onClick={()=>{removeTag(v)}} className={styles.tag} key={i}>{v[keys.name_top]}</p>
                })}
                
                <input type="text" placeholder={placeholder} onFocus={()=>{setshowDropdown(true)}} onChange={(e)=>handleSearchItem(e.currentTarget.value)}/>

                {showDropdown &&
                <div className={styles.dropdown_container}>
                    {Array.isArray(filtered_listItems) && filtered_listItems.length > 0 && <button name="action" onClick={()=>{handleSelectAll()}} className={styles.btn_selectall}><img src={checkbox} alt="checkbox"/>Selecteer alles</button>}
                    {Array.isArray(filtered_listItems) && filtered_listItems.length > 0 ? filtered_listItems.map((v, i)=>{
                        return <DropdownlistRow key={i} value={v} keys={keys} handleClickItem={()=>{handleSelectItem(v)}}/>
                    }) : <p>Geen items gevonden</p>}
                </div>
                } 
            </div>

                  

        </div>
    )
}

export const SelectedUser = ({value, index, keys, selectedGroupItems, showCheckbox, onSelect, onDelete}) => {
    return (
        <div className={style.list_row}>
            <div className={style.person_info}>
                <div className={style.profile_picture} style={(showCheckbox || selectedGroupItems.includes(value)) ? {display:"none"} : {}}>{value[keys.name_top].substring(0,1)}</div>
                <div className={style.checkbox}>
                    <input onChange={(e)=>{onSelect(e.currentTarget.checked)}} id={index.toString()+value[keys.name_bottom]} type="checkbox" checked={selectedGroupItems.includes(value)}/>
                    <label htmlFor={index.toString()+value[keys.name_bottom]}></label>
                </div>
                <div className={style.row_info}>
                    <p className={style.name_top}>{value[keys.name_top]}</p>
                    <p className={style.name_bottom}>{value[keys.name_bottom]}</p>
                </div>
            </div>
            <button onClick={()=>{onDelete(true)}} className={style.btn_delete}><img src={trash} alt="delete"/></button>
        </div>
    )
}

export default function GroupsPopup({onSave, data, crntGrp, keys, placeholder, group, onClose}){
    // const data = [
    //     {id:"4", name:"NV STERCKX-VANDEKERCKHOVE", relnr:"0000300001"},
    //     {id:"5", name:"NV STERCUS", relnr:"0000300003"},
    //     {id:"6", name:"LAMBRECHT MARC BVBA", relnr:"0000300005"},
    //     {id:"7", name:"DESNOUCK MARNIK", relnr:"0000300006"},
    //     {id:"8", name:"VAN DE MIEROP NV", relnr:"0000300007"},
    //     {id:"9", name:"EUTRACO  NV", relnr:"0000300008"}
    // ]
    // const crntGrp = []

    
    // const keys = {profile_picture:"name", name_top:"name", name_bottom:"relnr"}
    // const placeholder = "Relaties toevoegen";

    const [defaultName, setdefaultName] = useState("");

    useEffect(()=>{
        if(group){
            if(group.name){
                setgroupsname(group.name)
                setdefaultName(group.name)
            }
        }
    }, [group])


    useEffect(()=>{

        let tmp_data = [...data]

        tmp_data = tmp_data.filter((value, index) => {
            const _value = JSON.stringify(value);
            return index === tmp_data.findIndex(obj => {
              return JSON.stringify(obj) === _value;
            });
        });
        
        for (let i = 0; i < crntGrp.length; i++) {
            const index = tmp_data.findIndex(object => object.relnr.includes(crntGrp[i].relnr))
            if(index > -1){
                tmp_data.splice(index, 1);
            }
        }

        setrestData(tmp_data);
        setcurrentGroup(crntGrp);
    }, [crntGrp])

    const [clearDropdown, setclearDropdown] = useState(false);

    const [restData, setrestData] = useState(null);
    const [currentGroup, setcurrentGroup] = useState([]);

    const [selectedGroupItems, setselectedGroupItems] = useState([]);
    const [showCheckboxes, setshowCheckboxes] = useState(false);

    const [selectedUsers, setselectedUsers] = useState([]);

    const handleSelectUser = (v, bool) => {
        let tmp_selectedGroupItems = [...selectedGroupItems]
        if(bool === true){
            //Add to selectedGroupItems
            tmp_selectedGroupItems.push(v)
        }
        else {
            //Remove from selectedGroupItems
            const index = tmp_selectedGroupItems.findIndex(value => value.relnr.toString() ===  v.relnr.toString())
            if(index > -1){
                tmp_selectedGroupItems.splice(index, 1);
            }
        }
        setselectedGroupItems(tmp_selectedGroupItems)

        if(tmp_selectedGroupItems.length > 0){
            setshowCheckboxes(true);
        }
        else {
            setshowCheckboxes(false);
        }
    }
    
    const addUsersToGroup = () => {
        let tmp_selectedUsers = [...selectedUsers]
        
        //Add selectedUsers to currentGroup
        let tmp_currentGroup = [...currentGroup]
        tmp_currentGroup = tmp_currentGroup.concat(tmp_selectedUsers);

        //Remove selectedUsers from restData
        let tmp_restData  = [...restData]
        for (let i = 0; i < tmp_selectedUsers.length; i++) {
            const index = tmp_restData.findIndex(v => v.relnr.toString() ===  tmp_selectedUsers[i].relnr.toString())
            if(index > -1){
                tmp_restData.splice(index, 1);
            }
           
        }

        setcurrentGroup(tmp_currentGroup);
        setrestData(tmp_restData);
        setclearDropdown(true);
    }

    useEffect(()=>{setclearDropdown(false)}, [clearDropdown])

    const selectAll = () => {
        setshowCheckboxes(!showCheckboxes); 
        if(selectedGroupItems.length < [...filteredCurrentGroup].length){
            setselectedGroupItems([...filteredCurrentGroup])
        }
        else {
            setselectedGroupItems([])
        }
    }

    const deleteUser = (value) => {
        let tmp_currentGroup = [...currentGroup]
        let tmp_restData = [...restData]

        tmp_restData = tmp_restData.concat(value);

        const index = tmp_currentGroup.findIndex(v => v.relnr.toString() ===  value.relnr.toString())
        if(index > -1){
            tmp_currentGroup.splice(index, 1);
        }
        
        setcurrentGroup(tmp_currentGroup)
        setrestData(tmp_restData)
    }

    const bulkDeleteUsers = () => {
        let tmp_selectedGroupItems = [...selectedGroupItems]
        let tmp_currentGroup = [...currentGroup]
        let tmp_restData = [...restData]

        //Remove from current group
        for (let i = 0; i < tmp_selectedGroupItems.length; i++) {
            const index = tmp_currentGroup.findIndex(v => v.relnr.toString() ===  tmp_selectedGroupItems[i].relnr.toString())
            if(index > -1){
                tmp_currentGroup.splice(index, 1);
            }
        }

        //Add to restData
        if(!tmp_restData.includes(tmp_selectedGroupItems)){
            tmp_restData = tmp_restData.concat(tmp_selectedGroupItems);
        }

        setrestData(tmp_restData);
        setcurrentGroup(tmp_currentGroup)
        setselectedGroupItems([])
        setshowCheckboxes(false);
    }

    useEffect(()=>{
        setfilteredCurrentGroup([...currentGroup])
    }, [currentGroup])

    const [filteredCurrentGroup, setfilteredCurrentGroup] = useState([]);
    const searchCurrentGroup = (value) => {
        let tmp_currentGroup = [...currentGroup]
        let tmp_filteredCurrentGroup = []

        Object.keys(keys).forEach((key, index)=>{
            for (let i = 0; i < tmp_currentGroup.length; i++) {
                if(tmp_currentGroup[i][keys[key]].toString().toLowerCase().includes(value.toLowerCase())){
                    if(!tmp_filteredCurrentGroup.includes(tmp_currentGroup[i])){
                        tmp_filteredCurrentGroup.push(tmp_currentGroup[i])
                    }
                }
            }
        })

        setfilteredCurrentGroup(tmp_filteredCurrentGroup)
    }

    const [groupsname, setgroupsname] = useState("");


    //const refContainer = useDetectClickOutside({ onTriggered: function(e){closeTab(e)} });

    const closeTab = (e) => {
        if(e.target.name === "action"){return;}
        console.log(e.target)
        onClose(true);
    }

    return (
        <>
        <div className={style.popup_bg}>
            <div className={style.popup_cnt}>
                <h1>Gebruikersgroep</h1>
                <input defaultValue={defaultName} className={style.groupname_input} type="text" placeholder="Groepsnaam..." onChange={(e)=>{setgroupsname(e.currentTarget.value)}}/>

                <AdvancedDropdownlist clear={clearDropdown} data={restData} keys={keys} placeholder={placeholder} onChange={(value)=>{setselectedUsers(value)}}/>
                {selectedUsers.length > 0 && <button onClick={()=>{addUsersToGroup()}} className={style.btn_addusers}>Gebruikers toevoegen</button>}

                <div className={style.grp_bottom}>
                    <div>
                        <h2>Gebruikers in de groep</h2>
                        {filteredCurrentGroup.length > 0 ?
                        <div className={style.top_actions}>
                            <div className={style.top_actions_left}>
                                <button onClick={()=>{selectAll()}}><img src={checkbox} alt="checkbox"/>Selecteer alles</button>
                                <div className={style.search_field}><button><img src={search} alt="search"/></button><input onChange={(e)=>searchCurrentGroup(e.currentTarget.value)} type="text" placeholder="Zoeken..."/></div>
                            </div>
                            
                            {selectedGroupItems.length > 0 && <button onClick={()=>{bulkDeleteUsers()}}><img src={trash} alt="delete"/>Verwijder uit groep</button>}
                        </div>
                        :
                        <p>Geen gebruikers in deze groep</p>
                        }

                        <div className={style.selected_list}>
                        {filteredCurrentGroup.map((v, i)=>{
                            return <SelectedUser onDelete={()=>{deleteUser(v)}} onSelect={(bool)=>{handleSelectUser(v, bool)}} index={i} value={v} keys={keys} selectedGroupItems={selectedGroupItems} showCheckbox={showCheckboxes} key={i}/>
                        })}
                        </div>
                    </div>

                    <div className={style.bottom_actions}>
                        <button onClick={()=>{onClose()}} className={style.btn_cancel}>Sluiten</button>
                        <button onClick={()=>{onSave(currentGroup, groupsname)}} className={style.btn_save}>Opslaan</button>
                    </div>
                </div>

            </div>
        </div>
        </>
    )
}